(function($, undefined) {
	'use strict';
	var hubspot;
	var formValidator;
	var utils;
	var toast;
	var lang;

	var nextFormStep = function() {
		var btn = $(this);
		var currentStepNumber = btn.closest('.signup-step').data('step');
		var currentStep = $('.signup-step[data-step='+currentStepNumber+']');
		var nextStepNumber = btn.data('next-step');
		var nextStep = $('.signup-step[data-step='+nextStepNumber+']');
		var form = $('.signup-page__form');
		var signupEmailError = currentStep.find('.js-form-error-message.signup-email');
		var emailInput = form.find('input[name=email]');
		var pmiNumberInput = currentStep.find('input[name=pmiNumber]');
		var isMemberSignUp = $('.signup-page__tab_member').hasClass("tabs__tab_selected");
		var pmiNumberRecognizedMsg = $('.signup-form__recognized-pmi-number-msg', form);
		var emailRecognizedMsg = $('.signup-form__recognized-email-msg', form);

		$('.signup-page__form').addClass('signup-page_form-open');
		$('.signup-step__next-step-btn', nextStep).removeClass('signup-login-form__submit-btn');

		if (nextStepNumber === 1) {
			if ($('.signup-step_active').hasClass('signup-step_final')) {
				updateCompletionProgress(nextStep);
			}

			$('.signup-step_active').removeClass("signup-step_active");
			nextStep.addClass('signup-step_active');
			btn.closest('.tab-content').removeClass('tab-content_selected');
			$('.signup-page__tab-content_form').addClass('tab-content_selected');
		} else {
			var step = btn.closest('.signup-step');
			var formToValidate = step.attr("data-step") == '2' ? $('.signup-step__step2:visible', step) : step;

			formValidator.validateForm(formToValidate);

			if (!formToValidate.hasClass('has-error')) {
				form.addClass('has-processing_active');
			
				var _next = function() {
					if (nextStepNumber == 2) {
						$('.signup-step__step2_login').hide();
						$('.signup-step__step2_signup').show();

						var emailInputsCtn = $('.signup-step__step2_signup .signup-step__form-input_emails', nextStep);
						if (isMemberSignUp) {
							emailInputsCtn.removeClass("signup-step__form-input_emails_hide");
							emailInputsCtn.find("input").addClass("required");
							nextStep.addClass("validate-account-exists");
						} else {
							emailInputsCtn.addClass("signup-step__form-input_emails_hide");
							emailInputsCtn.find("input").removeClass("required");
							nextStep.removeClass("validate-account-exists");
						}
					}
					currentStep.removeClass('signup-step_active');
					nextStep.addClass('signup-step_active');
					updateCompletionProgress(nextStep);
					form.removeClass('has-processing_active');
				};

				if (currentStep.hasClass('login')) { // important this is first to bypass the other cases
					submitSignupLoginForm();
				} else if (currentStep.hasClass('validate-email')) {
					validateEmail(emailInput, function(exists) {
						if (exists) {
							form.removeClass('has-processing_active');
							emailInput.addClass('error');
							signupEmailError.slideDown();
						} else {
							signupEmailError.slideUp();
							emailInput.removeClass('error');
							_next();
						}
					});
				} 
				else if (currentStep.hasClass("validate-account-exists")) {
					var pmiNumber = pmiNumberInput.is(":visible") ? pmiNumberInput.val() : "";
					var email = emailInput.val();
					validateAccountExists(pmiNumber, email, (exists, whichMatches) => {
						if (isMemberSignUp && exists && nextStepNumber == '3') { // in case of member signup when email matches after step 2
							nextStepNumber = 2;
							nextStep = $('.signup-step[data-step='+nextStepNumber+']');
						}
						_next();
						if (exists) {
							nextStep.addClass("login");
							var loginForm = $('.signup-login-form');
							if (whichMatches == "pmiNumber") {
								$('[name=username]', loginForm).val("");
								$('.signup-login-form__email-input-wrap', loginForm).slideDown();
								pmiNumberRecognizedMsg.show();
								emailRecognizedMsg.hide();
							} 
							else {
								$('[name=username]', loginForm).val(emailInput.val());
								$('.signup-login-form__email-input-wrap', loginForm).slideUp();
								pmiNumberRecognizedMsg.hide();
								emailRecognizedMsg.show();
							}
							$('.signup-step__next-step-btn', nextStep).addClass('signup-login-form__submit-btn');
							$('.signup-step__step2_login').show();
							$('.signup-step__step2_signup').hide();
							form.removeClass('has-processing_active');
						} else {
							nextStep.removeClass("login");
							$('.signup-step__next-step-btn', nextStep).removeClass('signup-login-form__submit-btn');
							$('.signup-step__step2_login').hide();
							$('.signup-step__step2_signup').show();
						}
					});
				} else if (currentStep.hasClass('create-account')) {
					form.find('.select-state-input-ctn:not(.selected)').remove();
					hubspot.addContactToHubspot(form, () => {
						hubspot.toggleOptInsHubspotByContactEmail(emailInput.val(), 
							$('[name=newsletter2]', form).is(":checked"),
							$('[name=newsletter_cbx]', form).is(":checked"),
							() => {
								form.submit();
							});
					});
				} else {
					_next();
				}
			}
		}
	};

	var editPreviousFormStep = function() {
		var btn = $(this);
		var currentStepNumber = btn.closest('.signup-step').data('step');
		var previousStepNumber = btn.data('previous-step');
		var previousStep = $('.signup-step[data-step='+previousStepNumber+']');

		$('.signup-step[data-step='+currentStepNumber+']').removeClass('signup-step_active');
		previousStep.addClass('signup-step_active');
		updateCompletionProgress(previousStep);
	};

	var updateCompletionProgress = function(step) {
		$('.signup-page__completion-bar .completion-bar__inner').css('width', step.data('completion') + '%');

		if (utils.isSM()) {
			var target = $('.tab-content_selected').offset().top;
			if ($(window).scrollTop() > target) {
				target = target - $('.site-header__bottom').outerHeight();
			}
			$('html, body').animate({ scrollTop: target }, 500);
		}
	};

	// fonction provenant de VoilaCasting
	var validateEmail = function(email, callback = () => {}) {
		$.ajax("/action/validateUsername", {
			data: "username=" + encodeURIComponent(email),
			success: function(res) {
				console.log(res);
				callback(res.trim() !== "success", "email"); // success means it exists, error it doesn't
			}
		});
	};

	var validatePMINumber = function(pmiNumber, callback = () => {}) {
		$.ajax({
			url: "/action/pmiAccount",
			method: "get",
			data: {
				validateMemberWebsite: true,
				pmiNumber: pmiNumber,
			},
			cache: false,
			success: function(response) {
				console.log(response);
				callback(response.trim().split('-')[1] === "true", "pmiNumber");
			},
			error: function(jqxhr, status, error) {
				console.log(status + " " + error);
			}
		});
	}

	var validateAccountExists = function(pmiNumber, email, callback = () => {}) {
		if (pmiNumber) {
			validatePMINumber(pmiNumber, callback);
		} 
		else if (email) {
			validateEmail(email, callback, callback);
		}
		else {
			callback(false);
		}
	};

	var updateLoginRegisterHeight = function() {
		// if not responsive
		if (!utils.isSM()) {
			$('.login-register-page').css('height', 'calc(100vh - '+ $('.site-header').outerHeight() +'px)');
		} else {
			$('.login-register-page').css('height', 'auto');
		}
	};

	var handleSignupPageTabClick = function() {
		var btn = $(this);
		var pmiNumberInputCtn = $('.signup-step__form-input_pminumber');
		var emailInputsCtn = $('.signup-step[data-step=1] .signup-step__form-input_emails');
		var memberInfos = $('.signup-page__infos_member');
		var nonMemberInfos = $('.signup-page__infos_non-member');
		var pmiNumberInputLabel = $('label', pmiNumberInputCtn).first().text().replace(" *", "");
		var isOnSuccess = location.search.indexOf("signupSuccess") !== -1;
		var step1 = $('.signup-step_form[data-step=1]');

		if (btn.hasClass('signup-page__tab_member')) {
			pmiNumberInputCtn.slideDown(function() {
				pmiNumberInputCtn.find('input').addClass('required');
			});
			emailInputsCtn.slideUp(function() {
				emailInputsCtn.find('input').removeClass('required');
			});
			$('.signup-step_active').removeClass("signup-step_active");
			step1.addClass('signup-step_active');
			memberInfos.show();
			nonMemberInfos.hide();

			if (isOnSuccess) {
				var firstStep = $('.signup-page__step[data-step=1]');
				if (!firstStep.hasClass("signup-step_active")) {
					$('.signup-step_active').removeClass("signup-step_active");
					firstStep.addClass("signup-step_active");
					updateCompletionProgress(firstStep);
				}
			}
		} else {
			pmiNumberInputCtn.slideUp(function() {
				pmiNumberInputCtn.find('input').removeClass('required');
			});
			emailInputsCtn.slideDown(function() {
				emailInputsCtn.find('input').addClass('required');
			});
			nonMemberInfos.show();
			memberInfos.hide();
		}
	};

	var handleMemberTabClick = function() {
		$('.signup-page__form').addClass("signup-page_form-open");
	};

	var submitSignupLoginForm = function() {
		var form = $('.signup-login-form');
		var ctn = form.closest('.signup-page__form');
		var params = {
			"username": $('[name=username]', form).val(),
			"password": $('[name=password]', ctn).val(),
			"ajax": true
		};

		$('.form-message', form).slideUp();
		formValidator.validateForm(form);

		if (!form.hasClass("has-error")) {
			$.ajax({
				url: "/action/login",
				data: params,
				method: "post",
				cache: false,
				complete: function(response) {
					if (response.responseText.indexOf("success") !== -1) {
						location.href = $('[name=forward]', form).val();
					} else {
						ctn.removeClass("has-processing_active");
						$('.form-message_signup-login-error', form).slideDown();
					}
				}
			});
		}
		else {
			$('.form-message_no-password-error', form).slideDown();
		}
	};

	var onSignupEmailsChange = function() {
		var input = $(this);
		var ctn = input.closest('.signup-page__form');
		$('[name=email]', ctn).val(input.val()); // the latest updated is always the one we want because the other is hidden
	};

	var onSignupPasswordsChange = function() {
		var input = $(this);
		var ctn = input.closest('.signup-page__form');
		$('[name=password]', ctn).val(input.val()); // the latest updated is always the one we want because the other is hidden
	};


	var init = function() {
		hubspot = Fw.component.models().hubspot;
		utils = Fw.component.models().utils;
		formValidator = Fw.component.models().form;
		toast = Fw.component.models().toast;
		lang = $("html").attr("lang");

		$('.signup-step__next-step-btn').click(nextFormStep);
		$('.signup-step__previous-step-btn').click(editPreviousFormStep);
		$('.signup-page__tab').click(handleSignupPageTabClick);
		$('.signup-page__tab_member').click(handleMemberTabClick);
		$('.signup-step').on('click', '.signup-login-form__submit-btn', submitSignupLoginForm);
		$('.signup-page__form').find('[name=first-step-email], [name=second-step-email]').on('change', onSignupEmailsChange);
		$('.signup-page__form').find('[name=login-password], [name=signup-password]').on('change', onSignupPasswordsChange);

		updateLoginRegisterHeight();
		$(window).resize(function() {
			updateLoginRegisterHeight();
		});

		var urlParams = location.search.replace("?", "").split("&");
		if (urlParams.indexOf("signupSuccess") !== -1) {
			var signupSuccessMessage = $('.site-header__bottom').attr("data-logged-in-toast-message");
			toast.create(signupSuccessMessage, toast.DURATION.MEDIUM, "success");
		}
	};

	$(window).ready(function() {
		init();
	});
})(jQuery);